module.exports = __webpack_public_path__ + "static/media/skill6_pos_es.4f5e1196.txt";